"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const util_1 = require("../../../util");
const Stringify_1 = require("./Stringify");
exports.ButtonComponent = ({ action, row, col, colIndex, onAction, rowIndex, value, className, }) => {
    const handleClick = () => {
        if (!action || action.disabled)
            return;
        const creator = {
            row,
            column: col,
            colIndex,
            rowIndex,
        };
        const params = util_1.convertSerializedIntoJS(action.params, row, col);
        onAction({ ...action, action: action === null || action === void 0 ? void 0 : action.type, creator, params });
    };
    let { disabled } = action || {};
    if (action) {
        disabled = util_1.convertSerializedIntoJS(disabled, row, col);
    }
    return (react_1.default.createElement(reactstrap_1.Button, { className: className, disabled: disabled, onClick: handleClick, color: value.variant || "primary", size: "sm" },
        react_1.default.createElement(Stringify_1.Stringify, { col: col, value: value.child })));
};
//# sourceMappingURL=ButtonComponent.js.map